<template>
<div v-if="supplier !== null">
    <vx-card class="mb-4">
        <div class="row mt-0">
            <div class="col-md-2">
                <img :src="photoURL" alt="Logo">
            </div>
            <div class="col-md-8">
                <h3 class="mb-1">{{supplier.tradename}}</h3>
                <span>{{supplier.email}}</span>
                <h6>SID: <strong>{{supplier.id}}</strong> | UID: <strong>{{supplier.user_id}}</strong></h6>
            </div>
        </div>
    </vx-card>

    <vx-card>
        <vs-tabs position="top"  class="tabs-shadow-none" id="profile-tabs" >
            <!-- CONTACTO -->
            <vs-tab label="Contactos">
                <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <table class="table table-sm">
                        <tr v-for="contact in supplier.contacts" v-bind:key="contact.id">
                            <td class="table-dark">Contacto</td>
                            <td>
                                {{contact.name}} <br>
                                <small>{{contact.phone}}</small><br>
                                <small><a-secure :href="'mailto:'+contact.email">{{contact.email}}</a-secure></small>
                            </td>
                        </tr>
                    </table>
                </div>
            </vs-tab>
            <!-- BANCO -->
            <vs-tab label="Bancos">
                <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <table class="table table-sm">
                        <thead class="thead-dark">
                            <th>ID</th>
                            <th>Clabe</th>
                            <th>Banco</th>
                        </thead>
                        <tbody>
                            <tr v-for="bank in supplier.user.fiscal.bank_accounts" v-bind:key="bank.id">
                                <td>{{bank.id}}</td>
                                <td>{{bank.clabe}}</td>
                                <td>{{bank.bank.short_name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-tab>
            <!-- AGENTES -->
            <vs-tab label="Vendedores">
                <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <table class="table table-sm">
                        <thead class="thead-dark">
                            <th>Nombre</th>
                            <th>Correo</th>
                            <th>Teléfono</th>
                        </thead>
                        <tbody>
                            <tr v-for="agent in agents">
                                <td>{{agent.name}}</td>
                                <td>{{agent.email}}</td>
                                <td>{{agent.phone}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-tab>
        </vs-tabs>
    </vx-card>
</div>
</template>
<script>
import ASecure from "@components/utils/aSecure";
export default {
    name: "supplier-details",
  components: {ASecure},
  props:["supplier_id"],
    data() {
        return {
            supplier: null
            , agents: []
            , avatar: require('@assets/images/supplier_avatar.png')
        }
    },
    computed:{
        photoURL(){
            return this.avatar;
        },
    },
    mounted() {
        this.update();
        this.getSupplierAgents();
    },
    methods: {
        update(supplier_id = this.supplier_id) {
            axios.get("/api/supplier/" + supplier_id)
            .then((res) => {
                this.supplier = res.data
            })
        },
        async getSupplierAgents(supplier_id = this.supplier_id){
            try {
                const response = await axios.get('/api/supplier/admin/agents/' + supplier_id);
                this.agents = response.data;
            } catch (error) {
                console.info(error);
            }
        }
    }
}
</script>
